import styled, { css } from "styled-components";
import { Colors, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "../../../../core";
import { AgreeWrapper } from "../../../modals/styles";

export const FileInput = styled.input`
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  display: block !important;
  opacity: 0;
  z-index: 3;
  cursor: pointer;
`

export const ImagePreviewSectionHolder = styled(FlexBox)`
  position: absolute;
  ${Fonts.Inter.smallText};
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;

  @media (max-width: 940px) {
    align-items: center;

    justify-content: center;
    font-size: 13px;
  }
`;

export const Wrapper = styled(FlexBox)`
  width: 100%;
  max-width: 300px;
  position: relative;
`

export const ImagePreview = styled.div<{ url: string }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("${({ url }) => url || 'none'}");
  background-size: cover;
  background-position: center;
  z-index: 2;
`

export const Divider = styled.div`
  
`

export const GridRow = styled(FlexBox)<{ isBook?: boolean, center?: boolean, isTeamEdit?: boolean, isCheckbox?: boolean, switchValue?: number, isProDeziiign?: boolean  }>`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  align-items: start;


  input {
    font-size: 15px !important;
    line-height: 20px !important;

    @media(max-width: ${LayoutConst.screen.s-1}px) {
      font-size: 13px !important;
      line-height: 16px !important;
    }
  }


  ${({ isTeamEdit }) => isTeamEdit && css`
    input {
      padding-top: 15px;
      padding-bottom: 13px;
    }

    .add-button {
      height: 36px;
      max-height: 36px;
      min-height: 36px;

      span {
        font-size: 15px;
        line-height: 20px;
      }
    }

    .small-caption {
      font-size: 17px;
      line-height: 22px;
    }

    .brg-input__control {
      .brg-input__indicator {
        opacity 1 !important;
        transition: none;
        svg path {
            fill: #909090 !important;
        }
      }
    }
      @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
  `};

  input:not(:disabled, .protect-input)  {
    color: #151514 !important;
  }
  
  .input-span {
    color: rgba(144, 144, 144, 1);
  }

  .header-description {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  .showcase-switcher {
    margin-bottom: 0;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: rgba(112, 112, 111, 1);
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
  }
  
  ${AgreeWrapper} {
    margin-top: 0;
  }

  .tags-container {
    max-width: 413px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 293px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      max-width: 100%;
    }
  }
  
  ${({ center}) => center ? css`
    place-items:center;
  `: null};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    align-items: start;
  }

  @media(max-width: 940px) {
    ${({ center}) => center ? css`
    place-items:normal;
  `: null};
    .project-tags-block {
      flex-direction: column !important;
    }

    
    &.mobile__hide {
      display: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isCheckbox }) => isTeamEdit ? css`
      flex-flow: ${isCheckbox ? 'row-reverse' : 'column'};
      width:100%;
    ` : null};
  }

  @media(max-width: 440px) {

    ${({ isBook }) => isBook ? css`
    .add-button {
      margin-left: 0 !important;
    }
      input {
        max-width: 202px;
      }
    ` : null}
  }
`;

export const MainTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 60px;
  line-height: 70px;
  letter-spacing: -2%;
  
    white-space: nowrap;
    color: ${({ theme }) => theme.sendProjectsModal.title};
    margin-bottom: 32px;

    @media (max-width: ${LayoutConst.screen.m}px){
      font-size: 28px;
      line-height: 34px;

    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
      
    }
`;

export const LoadTitle = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 133.333% */
  letter-spacing: -0.3px;
  color: #343434;
  text-align: center;
`;
import styled, { css } from "styled-components";
import { Colors, FlexBox, Fonts } from "@brg/ui";
import { LayoutConst } from "../../../../core";
import { AgreeWrapper } from "../../../modals/styles";

export const FileInput = styled.input`
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  display: block !important;
  opacity: 0;
  z-index: 3;
  cursor: pointer;
`

export const ImagePreviewSectionHolder = styled(FlexBox)`
  position: absolute;
  ${Fonts.Inter.smallText};
  color: ${Colors.galBlack47};
  background: ${(p) => p.theme.projectEdit.imgContainerBg};
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;

  @media (max-width: 940px) {
    align-items: center;

    justify-content: center;
    font-size: 13px;
  }
`;

export const Wrapper = styled(FlexBox)`
  width: 100%;
  max-width: 300px;
  position: relative;
`

export const ImagePreview = styled.div<{ url: string }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("${({ url }) => url || 'none'}");
  background-size: cover;
  background-position: center;
  z-index: 2;
`

export const Divider = styled.div`
  
`

export const GridRow = styled(FlexBox)<{ isBook?: boolean, center?: boolean, isTeamEdit?: boolean, isCheckbox?: boolean, switchValue?: number, isProDeziiign?: boolean  }>`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  align-items: start;


  input {
    font-size: 15px !important;
    line-height: 20px !important;

    @media(max-width: ${LayoutConst.screen.s-1}px) {
      font-size: 13px !important;
      line-height: 16px !important;
    }
  }


  ${({ isTeamEdit }) => isTeamEdit && css`
    input {
      padding-top: 15px;
      padding-bottom: 13px;
    }

    .add-button {
      height: 36px;
      max-height: 36px;
      min-height: 36px;

      span {
        font-size: 15px;
        line-height: 20px;
      }
    }

    .small-caption {
      font-size: 17px;
      line-height: 22px;
    }

    .brg-input__control {
      .brg-input__indicator {
        opacity 1 !important;
        transition: none;
        svg path {
            fill: #909090 !important;
        }
      }
    }
      @media(max-width: ${LayoutConst.screen.m}px){
        max-width: 720px;
    }
  `};

  input:not(:disabled, .protect-input)  {
    color: #151514 !important;
  }
  
  .input-span {
    color: rgba(144, 144, 144, 1);
  }

  .header-description {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  .showcase-switcher {
    margin-bottom: 0;
    height: 24px;
    width: 48px;

    span:not(:last-child) {
      background-color: rgba(112, 112, 111, 1);
      border-radius: 19px;
    }

    span:last-child {
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      border-radius: 50%;
      left: 10%;
      ${({ switchValue }) => switchValue === 0 ? css`
      background-color: #fff;
      ` : css`
        left: 57%;
      `};
    }
  }
  
  ${AgreeWrapper} {
    margin-top: 0;
  }

  .tags-container {
    max-width: 413px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 293px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      max-width: 100%;
    }
  }
  
  ${({ center}) => center ? css`
    place-items:center;
  `: null};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    align-items: start;
  }

  @media(max-width: 940px) {
    ${({ center}) => center ? css`
    place-items:normal;
  `: null};
    .project-tags-block {
      flex-direction: column !important;
    }

    
    &.mobile__hide {
      display: none;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    ${({ isTeamEdit, isCheckbox }) => isTeamEdit ? css`
      flex-flow: ${isCheckbox ? 'row-reverse' : 'column'};
      width:100%;
    ` : null};
  }

  @media(max-width: 440px) {

    ${({ isBook }) => isBook ? css`
    .add-button {
      margin-left: 0 !important;
    }
      input {
        max-width: 202px;
      }
    ` : null}
  }
`;

export const MainTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 60px;
  line-height: 70px;
  letter-spacing: -2%;
  
    white-space: nowrap;
    color: ${({ theme }) => theme.sendProjectsModal.title};
    margin-bottom: 32px;

    @media (max-width: ${LayoutConst.screen.m}px){
      font-size: 28px;
      line-height: 34px;

    }

    @media (max-width: ${LayoutConst.screen.s -1}px){
      
    }
`;

export const LoadTitle = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 133.333% */
  letter-spacing: -0.3px;
  color: #343434;
  text-align: center;
`;
